import { createApi } from '@core/fetch'

export default {
  // 创建合作订单
  createCooperateOrder: createApi.post(
    '/p/wedding/Admin/APICrmBrokerage/createCooperateOrder'
  ),
  // 合作订单创建信息
  getCooperateOrder: createApi(
    '/p/wedding/Admin/APICrmBrokerage/cooperateOrderInfo'
  ),
  // 服务费账户余额信息
  getBrokerageBalanceInfo: createApi(
    '/p/wedding/Admin/APICrmBrokerage/brokerageBalanceInfo'
  ),
  // 获取服务费申请记录
  getBrokerageOrder: createApi(
    '/p/wedding/Admin/APICrmBrokerage/brokerageOrder'
  ),
  // 申请扣除服务费
  createBrokerageOrder: createApi.post(
    '/p/wedding/Admin/APICrmBrokerage/createBrokerageOrder'
  ),
  // 申请退还服务费
  applyRefund: createApi.post('/p/wedding/Admin/APICrmBrokerage/applyRefund'),
  // 合作订单明细
  cooperateOrderList: createApi(
    '/p/wedding/Admin/APICrmBrokerage/cooperateOrderList'
  ),
  // 合作订单详情
  cooperateOrderDetail: createApi(
    '/p/wedding/Admin/APICrmBrokerage/cooperateOrderDetail'
  ),
  // 服务费账户信息
  brokerageInfo: createApi('/p/wedding/Admin/APICrmBrokerage/brokerageInfo'),
  // 流水明细
  flowOrderList: createApi('/p/wedding/Admin/APICrmBrokerage/flows'),
  // 服务费月度账单
  monthFlows: createApi('/p/wedding/Admin/APICrmBrokerage/monthFlows')
}
